import { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { axiosInstance } from '@/axiosConfig';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();
    
    // Estados para controlar a tela
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('Verificando seu e-mail...');

    // 1. A REF MÁGICA (Obrigatório declarar aqui)
    const dataFetchedRef = useRef(false);

    useEffect(() => {
        // Validação inicial
        if (!token) {
            setStatus('error');
            setMessage('Link inválido. Token não encontrado.');
            return;
        }

        // 2. O BLOQUEIO DA DUPLICIDADE
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        const verificarToken = async () => {
            try {
                // Chama sua rota (agora correta com /auth/...)
                await axiosInstance.post(`/auth/verify-email?token=${token}`);
                
                setStatus('success');
                setMessage('E-mail verificado com sucesso!');
                toast.success("Verificado! Redirecionando...");
                
                // Espera um pouquinho pro usuário ler antes de redirecionar
                setTimeout(() => navigate('/login'), 2000);

            } catch (error) {
                console.error(error);
                
                // Tratamento de erro melhorado
                setStatus('error');
                // Pega a mensagem do Backend ou usa uma genérica
                const msgErro = error.response?.data?.detail || "Erro ao verificar e-mail.";
                setMessage(msgErro);
            }
        };

        verificarToken();
        
    }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md text-center p-6 shadow-lg">
        <div className="flex justify-center mb-6">
          {status === 'loading' && <Loader2 className="h-16 w-16 text-blue-500 animate-spin" />}
          {status === 'success' && <CheckCircle className="h-16 w-16 text-green-500" />}
          {status === 'error' && <XCircle className="h-16 w-16 text-red-500" />}
        </div>
        
        <CardTitle className="text-2xl mb-2">
          {status === 'loading' && 'Verificando...'}
          {status === 'success' && 'Conta Ativada!'}
          {status === 'error' && 'Falha na Ativação'}
        </CardTitle>
        
        <CardDescription className="text-gray-600 mb-6 text-base">
          {message}
        </CardDescription>

        <CardContent>
          {status === 'success' && (
            <Button 
              className="w-full bg-blue-600 hover:bg-blue-700 py-6 text-lg"
              onClick={() => navigate('/login')}
            >
              Ir para o Login
            </Button>
          )}
          {status === 'error' && (
            <Button variant="outline" className="w-full" onClick={() => navigate('/login')}>
              Voltar ao Início
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}